export type Optional<T extends object> = {
  [P in keyof T]?: T[P];
};

export type PageSettings = Optional<{
  /**
   * @description Use this setting to hide your profile picture, name, event duration, location, and description when Calendly is embedded. This will help reduce duplicate information that you may already have on your web page.
   * @see {@link https://help.calendly.com/hc/en-us/articles/360020052833-Advanced-embed-options#2} for further information.
   */
  hideLandingPageDetails: boolean;
  /**
   * @description Use this setting to hide your profile picture, name, event duration, location, and description when Calendly is embedded. This will help reduce duplicate information that you may already have on your web page.
   * @see {@link https://help.calendly.com/hc/en-us/articles/360020052833-Advanced-embed-options#2} for further information.
   */
  hideEventTypeDetails: boolean;
  /**
   * @description This setting is only available for Calendly users on the Pro plan. Use this setting to change your Calendly scheduling page's background color.
   * @example 00a2ff
   * @see {@link https://help.calendly.com/hc/en-us/articles/223147027-Embed-options-overview#3} for further information.
   */
  backgroundColor: string;
  /**
   * @description This setting is only available for Calendly users on the Pro plan. Use this setting to change your Calendly scheduling page's text color.
   * @example ffffff
   * @see {@link https://help.calendly.com/hc/en-us/articles/223147027-Embed-options-overview#3} for further information.
   */
  textColor: string;
  /**
   * @description This setting is only available for Calendly users on the Pro plan. Use this setting to change your Calendly scheduling page's primary color.
   * @example 4d5055
   * @see {@link https://help.calendly.com/hc/en-us/articles/223147027-Embed-options-overview#3} for further information.
   */
  primaryColor: string;
  /**
   * @description The General Data Protection Regulation governs data protection in the EU and EEA. Certain Calendly integrations require access to cookies with user information. If you do not embed the GDPR banner, users in those areas will not have the ability to give their consent in order to access integrations such as Google Analytics, Facebook Pixel, PayPal, and Stripe.
   * @see {@link https://help.calendly.com/hc/en-us/articles/360007385493-Cookie-FAQs} for further information.
   */
  hideGdprBanner: boolean;

  phoneNumber: string;
}>;

export interface ScriptOptions {
  src: string;
  onLoad?: () => void;
  async?: boolean;
}
export interface Prefill {
  name: string;
  email: string;
  phone: string;
  utm: PrefillUTM;
  customAnswers?: {
    a1?: string | number;
    a2?: string | number;
  };
}
export interface PrefillUTM {
  utmSource: string;
}

interface CalendlyInitOptions {
  url: string;
  parentElement: HTMLElement;
  prefill: Partial<Prefill>;
  utm?: PrefillUTM;
}

interface CalendlyGlobalObject {
  initInlineWidget(options: CalendlyInitOptions): void;
}

export interface CalendlyProps {
  onEventScheduled?: () => void;
  prefill?: Partial<Prefill>;
  pageSettings?: PageSettings;
}

declare global {
  interface Window {
    Calendly: CalendlyGlobalObject;
  }
}

export const CalendlyTestConstants = {
  calendlyContainerId: 'calendly-integration-container',
};
